export class DirectoryApplicationSummary {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialCount",
            "baseName": "credentialCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "redirectUriCount",
            "baseName": "redirectUriCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "declaredPermissionCount",
            "baseName": "declaredPermissionCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "appRoleCount",
            "baseName": "appRoleCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "earliestCredentialExpiry",
            "baseName": "earliestCredentialExpiry",
            "type": "string",
            "format": ""
        },
        {
            "name": "tenantOwned",
            "baseName": "tenantOwned",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DirectoryApplicationSummary.attributeTypeMap;
    }
    constructor() {
    }
}
